import { render, staticRenderFns } from "./AppStoreShowView.vue?vue&type=template&id=2ad3f5a6&scoped=true&"
import script from "./AppStoreShowView.vue?vue&type=script&lang=js&"
export * from "./AppStoreShowView.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreShowView.scss?vue&type=style&index=0&id=2ad3f5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3f5a6",
  null
  
)

export default component.exports